var _filter, _filter2, _rect, _rect2, _text, _g, _path, _circle, _path2, _path3, _circle2, _path4, _path5, _circle3, _path6, _path7, _circle4, _path8, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcpArchitecture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "agentGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "serverGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22c55e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#16a34a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "serverGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d97706"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "serverGrad3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#dc2626"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "serverGrad4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 4,
    floodOpacity: 0.3
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glowBlue"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#0f172a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 760,
    height: 410,
    rx: 20,
    fill: "#1e293b",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 55,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: "bold"
  }, "MCP Architecture")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 200)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -80,
    width: 140,
    height: 160,
    rx: 15,
    fill: "#1e293b",
    stroke: "#3b82f6",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.5;1;0.5",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -50,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 12
  }, "MCP CLIENT"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 10,
    r: 40,
    fill: "url(#agentGrad)",
    filter: "url(#glowBlue)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "40;43;40",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 11
  }, "AI"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "AGENT"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -8,
    r: 8,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4,-8 Q0,-14 4,-8",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170,150 Q300,100 430,100",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path1"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M170,150 Q300,100 430,100",
    fill: "none",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170,180 Q300,180 430,180",
    fill: "none",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    fill: "#f59e0b"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.2s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path2"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M170,180 Q300,180 430,180",
    fill: "none",
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170,210 Q300,260 430,260",
    fill: "none",
    stroke: "#ef4444",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    fill: "#ef4444"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.4s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path3"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M170,210 Q300,260 430,260",
    fill: "none",
    stroke: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170,240 Q300,340 430,340",
    fill: "none",
    stroke: "#8b5cf6",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    fill: "#8b5cf6"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.6s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#path4"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M170,240 Q300,340 430,340",
    fill: "none",
    stroke: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(530, 100)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -35,
    width: 160,
    height: 70,
    rx: 10,
    fill: "#1e293b",
    stroke: "#22c55e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.6;1;0.6",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -45,
    cy: 0,
    r: 20,
    fill: "url(#serverGrad1)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -48,
    cy: -3,
    r: 7,
    fill: "none",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -43,
    y1: 2,
    x2: -38,
    y2: 7,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: -5,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "Search"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 12,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "MCP Server"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(530, 180)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -35,
    width: 160,
    height: 70,
    rx: 10,
    fill: "#1e293b",
    stroke: "#f59e0b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.6;1;0.6",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -45,
    cy: 0,
    r: 20,
    fill: "url(#serverGrad2)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -6,
    width: 20,
    height: 12,
    rx: 2,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55,-6 L-45,2 L-35,-6",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: -5,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "Email"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 12,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "MCP Server"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(530, 260)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -35,
    width: 160,
    height: 70,
    rx: 10,
    fill: "#1e293b",
    stroke: "#ef4444",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.6;1;0.6",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -45,
    cy: 0,
    r: 20,
    fill: "url(#serverGrad3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: -45,
    cy: -6,
    rx: 10,
    ry: 4,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55,-6 L-55,6 Q-45,14 -35,6 L-35,-6",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: -5,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "Database"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 12,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "MCP Server"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(530, 340)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -80,
    y: -35,
    width: 160,
    height: 70,
    rx: 10,
    fill: "#1e293b",
    stroke: "#8b5cf6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    values: "0.6;1;0.6",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.9s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -45,
    cy: 0,
    r: 20,
    fill: "url(#serverGrad4)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.9s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -45,
    cy: 0,
    r: 9,
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -45,
    cy: 0,
    rx: 4,
    ry: 9,
    fill: "none",
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -54,
    y1: 0,
    x2: -36,
    y2: 0,
    stroke: "white",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: -5,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 12
  }, "Web"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 12,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 10
  }, "MCP Server"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -12,
    width: 60,
    height: 24,
    rx: 12,
    fill: "#22c55e",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#22c55e",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Tool"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -12,
    width: 60,
    height: 24,
    rx: 12,
    fill: "#f59e0b",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#f59e0b",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Tool"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -12,
    width: 60,
    height: 24,
    rx: 12,
    fill: "#ef4444",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#ef4444",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Tool"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 340)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -12,
    width: 60,
    height: 24,
    rx: 12,
    fill: "#8b5cf6",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    textAnchor: "middle",
    fill: "#8b5cf6",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Tool"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -100,
    cy: 0,
    r: 5,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("text", {
    x: -85,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Agent"), /*#__PURE__*/React.createElement("line", {
    x1: -30,
    y1: 0,
    x2: 0,
    y2: 0,
    stroke: "#22c55e",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Function Call"), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: -8,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#1e293b",
    stroke: "#8b5cf6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 4,
    fill: "#94a3b8",
    fontFamily: "Arial, sans-serif",
    fontSize: 11
  }, "Server"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcpArchitecture);
export default __webpack_public_path__ + "static/media/mcp-architecture.cd0f73dd50f422b468792ff77e5d1833.svg";
export { ForwardRef as ReactComponent };